import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgAisModule } from 'angular-instantsearch';
import { MatRadioModule } from '@angular/material/radio';
import { CatalogSnippetModule } from '@app/shared/components/catalog/catalog-snippet/catalog-snippet.module';
import { CatalogComponent } from '@app/shared/components/catalog/catalog.component';

import { AlertsModule } from '@app/shared/components/alerts/alerts.module';
import { CustomSortBySelectorComponent } from './custom-widgets/custom-sort-by-selector/custom-sort-by-selector.component';
import { CatalogHeaderComponent } from './catalog-header/catalog-header.component';
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module';
import { RefinementsService } from '@app/shared/components/catalog/services/refinements.service';
import { CatalogFiltersComponent } from './catalog-filters/catalog-filters.component';
import { CatalogSortComponent } from './catalog-sort/catalog-sort.component';
import {
  CatalogWidgetCurrentRefinementsComponent,
  CatalogWidgetCheckboxListComponent,
  CatalogWidgetShortCheckboxListComponent,
  CatalogWidgetHierarchicalMenuComponent,
  CatalogWidgetPriceRangeComponent,
  CatalogWidgetToggleComponent,
  CatalogWidgetHitsPerPageComponent,
  CatalogWidgetPaginationComponent,
  CatalogWidgetColorsComponent,
  CatalogWidgetLocationsCheckboxListComponent
} from '@app/shared/components/catalog/catalog-widgets';
import { ShowMoreButtonComponent } from './catalog-widgets/show-more-button/show-more-button.component';
import { SvgModule } from '@app/shared/components/svg/svg.module';
import { CatalogActionBarComponent } from './catalog-action-bar/catalog-action-bar.component';
import { ImagesModule } from '@app/shared/components/images/images.module';
import { InstantSearchService } from './services/instantsearch.service';
import { CatalogStateComponent } from './catalog-state/catalog-state.component';
import { RefModule } from '@app/shared/components/ref/ref.module';
import { CatalogSeoContentComponent } from './catalog-seo-content/catalog-seo-content.component';
import { SharedPipesModule } from '@app/shared/pipes/shared-pipes.module';
import { MappingServiceHash } from './services/mapping.service';
import { FiltersService } from './services/filters.service';
import { CatalogSuggestionsComponent } from '@app/+catalog/catalog-suggestions/catalog-suggestions.component';
import { ModalSustainabilityModule } from '@app/shared/components/modals/modal-sustainability/modal-sustainability.module';
import { CatalogSustainableComponent } from './catalog-sustainable/catalog-sustainable.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgAisModule,
    MatRadioModule,
    CatalogSnippetModule,
    AlertsModule,
    BreadcrumbModule,
    SvgModule,
    ImagesModule,
    RefModule,
    SharedPipesModule,
    ModalSustainabilityModule
  ],
  declarations: [
    CatalogComponent,
    CatalogStateComponent,
    CatalogHeaderComponent,
    CatalogFiltersComponent,
    CatalogSortComponent,
    CatalogActionBarComponent,
    CatalogSuggestionsComponent,

    // Widgets
    CatalogWidgetCurrentRefinementsComponent,
    CatalogWidgetCheckboxListComponent,
    CatalogWidgetShortCheckboxListComponent,
    CatalogWidgetHierarchicalMenuComponent,
    CatalogWidgetPriceRangeComponent,
    CatalogWidgetToggleComponent,
    CustomSortBySelectorComponent,
    ShowMoreButtonComponent,
    CatalogWidgetHitsPerPageComponent,
    CatalogWidgetPaginationComponent,
    CatalogWidgetColorsComponent,
    CatalogSeoContentComponent,
    CatalogWidgetLocationsCheckboxListComponent,
    CatalogSustainableComponent
  ],
  entryComponents: [],
  exports: [CatalogComponent, RouterModule],
  providers: [RefinementsService, InstantSearchService, MappingServiceHash, FiltersService]
})
export class CatalogModule {}
